import React, { lazy } from 'react';
import { componentsMenu, dashboardMenu, demoPages, extraMenu, layoutMenu, userMenu, boardMenu } from '../menu';
import Login from '../page/Auth/Login';

const DASHBOARD = {
	DASHBOARD: lazy(() => import('../page/dashboard/Dashboard')),
};
const COSYSMANAGEMENT = {
	COSYSMANAGEMENT: lazy(() => import('../page/Management/CoSys/PartCompManagement'))
}
const USERPROFILE = {
	PROFILE: lazy(() => import('../page/profile/Profile')),
};
const USER_PAGE = {
	GMAIL: lazy(() => import('../page/UserPage/Gmail')),
};
const BOARDINFO = {
	NOTICEBOARD: lazy(() => import('../page/BoardInfo/NoticeBoard')),
	DETAILNOTICEBOARD: lazy(() => import('../page/BoardInfo/component/DetailNoticeBoard')),
	FREEBOARD: lazy(() => import('../page/BoardInfo/FreeBoard')),
	DETAILFREEBOARD: lazy(() => import('../page/BoardInfo/component/DetailFreeBoard')),
};
const USER = {
	USER: lazy(() => import('../page/Management/User/UserManagement')),
}
const AUTH = {
	AUTH: lazy(() => import('../page/Management/Auth/AuthUserManagement')),
	AUTHCCP: lazy(() => import('../page/Management/Auth/CCPMenuManagement'))
}
const CONNSYS = {
	CONNSYS: lazy(() => import('../page/Management/ConnectionSystem/ConnentionSysManagement')),
}
const INTERFACE = {
	LOG : lazy(() => import('../page/Management/Interface/InterfaceLogPage')),
}
const SAP = {
	VENDORMENAGEMENT : lazy(() => import('../page/Management/SAPVendor/SapManage')),
}
const DCMANAGEMENT = {
	KEMUSERMANAGEMENT: lazy(() => import('../page/DCManagement/KemHrManage')),
	SAPMANAGEMENT: lazy(() => import('../page/DCManagement/SapManage')),
	USERMANAGEMENT: lazy(() => import('../page/DCManagement/UserManagement')),
	TEMPUSERMANAGEMENT: lazy(() => import('../page/DCManagement/TempUserManagement')),
	SYSTEMAUTHORITYMANAGEMENT: lazy(() => import('../page/DCManagement/SystemAuthorityManagement')),
	SYSTEMAUTHAPPLYMANAGEMENT: lazy(() => import('../page/DCManagement/SystemAuthApplyManagement')),
	SYSTEMUSERAPPLYMANAGEMENT: lazy(() => import('../page/DCManagement/SystemUserApplyManagement')),
	AUTHUSERMANAGEMENT: lazy(() => import('../page/AuthManagement/AuthUserManagement')),
};
const AUTHMANAGEMENT = {
	AUTHINQUIRY: lazy(() => import('../page/AuthManagement/AuthInquiry')),
	AUTHMENUMANAGEMENT: lazy(() => import('../page/AuthManagement/AuthMenuManagement')),
	INTERLOCKLINKMANAGEMENT: lazy(() => import('../page/AuthManagement/InterlockLinkManagement')),
	
};
const SRMAUTHMANAGEMENT = {
	SRMAUTHINQUIRY: lazy(() => import('../page/AuthManagement/SrmAuthInquiry')),
	SRMAUTHUSERREGMANAGEMENT: lazy(() => import('../page/AuthManagement/SrmAuthUserRegManagement')),
	SRMAUTHUSERMANAGEMENT: lazy(() => import('../page/AuthManagement/SrmAuthUserManagement')),
	SRMAUTHPRIVMANAGEMENT: lazy(() => import('../page/AuthManagement/SrmAuthPrivManagement')),
};

const KANBANAUTHMANAGEMENT = {
	KANBANAUTHINQUIRY: lazy(() => import('../page/AuthManagement/KanbanAuthInquiry')),
	KANBANAUTHUSERREGMANAGEMENT: lazy(() => import('../page/AuthManagement/KanbanAuthUserRegManagement')),
	KANBANAUTHUSERMANAGEMENT: lazy(() => import('../page/AuthManagement/KanbanAuthUserManagement')),
	KANBANAUTHPRIVMANAGEMENT: lazy(() => import('../page/AuthManagement/KanbanAuthPrivManagement')),
};

const EAIAUTHMANAGEMENT = {
	EAIAUTHINQUIRY: lazy(() => import('../page/AuthManagement/EaiAuthInquiry')),
	EAIAUTHUSERREGMANAGEMENT: lazy(() => import('../page/AuthManagement/EaiAuthUserRegManagement')),
	EAIAUTHUSERMANAGEMENT: lazy(() => import('../page/AuthManagement/EaiAuthUserManagement')),
	EAIAUTHPRIVMANAGEMENT: lazy(() => import('../page/AuthManagement/EaiAuthPrivManagement')),
};

const ORGANIZATIONMANAGEMENT = {
	ORGANIZATIONMANAGEMENT: lazy(() =>
		import('../page/OrganizationManagement/OrganizationManagePage'),
	),
};

const presentation = [
	/*
	 *  사용자프로필
	 */
	{
		id: 'dashboard',
		path: dashboardMenu.dashboard.path,
		element: <DASHBOARD.DASHBOARD />,
		exact: true,
	},
	/*
	 *  사용자프로필
	 */
	{
		id: 'profile',
		path: extraMenu.profile.path,
		element: <USERPROFILE.PROFILE />,
		exact: true,
	},
	{
		id: 'gmail',
		path: userMenu.gmail.path,
		element: <USER_PAGE.GMAIL />,
		exact: true,
	},
	/*
	 *	게시판
	 */
	// {
	// 	id: 'user',
	// 	path: dashboardMenu.boardInfo.subMenu.noticeBoard.path,
	// 	element: <BOARDINFO.NOTICEBOARD />,
	// 	exact: true,
	// },
	// {
	// 	id: 'user',
	// 	path: dashboardMenu.boardInfo.subMenu.freeBoard.path,
	// 	element: <BOARDINFO.FREEBOARD />,
	// 	exact: true,
	// },
	// {
	// 	id: 'user',
	// 	path: dashboardMenu.boardInfo.subMenu.detailNoticeBoard.path,
	// 	element: <BOARDINFO.DETAILNOTICEBOARD />,
	// 	exact: true,
	// },
	// {
	// 	id: 'user',
	// 	path: dashboardMenu.boardInfo.subMenu.detailFreeBoard.path,
	// 	element: <BOARDINFO.DETAILFREEBOARD />,
	// 	exact: true,
	// },
	/*
	 *	사용자 관리
	 */
	 {
		id: 'user',
		path: dashboardMenu.user.path,
		element: <USER.USER />,
		exact: true,
	},
	/*
	 *	권한 관리
	 */
	//  {
	// 	id: 'auth',
	// 	path: dashboardMenu.auth.subMenu.authDC.path,
	// 	element: <AUTH.AUTH />,
	// 	exact: true,
	// },
	// {
	// 	id: 'authccp',
	// 	path: dashboardMenu.auth.subMenu.authCCP.path,
	// 	element: <AUTH.AUTHCCP />,
	// 	exact: true,
	// },
	/*
	 *	참여업체 관리
	 */
	// {
	// 	id: 'cosys',
	// 	path: dashboardMenu.coSysManagement.path,
	// 	element: <COSYSMANAGEMENT.COSYSMANAGEMENT />,
	// 	exact: true,
	// },
	/*
	 *	협력사 관리
	 */
	{
		id: 'sapVendorManagement',
		path: dashboardMenu.SAPVendorManagement.path,
		element: <SAP.VENDORMENAGEMENT />,
		exact: true,
	},
	/*
	 *	인터페이스 로그
	 */
	// {
	// 	id: 'interfaceLog',
	// 	path: dashboardMenu.interfaceLog.path,
	// 	element: <INTERFACE.LOG />,
	// 	exact: true,
	// },
	/*
	 *	연결 시스템 관리
	 */
	 {
		id: 'connentionSysManagement',
		path: dashboardMenu.connentionSystem.path,
		element: <CONNSYS.CONNSYS />,
		exact: true,
	},

	/*
	 *	DC관리
	 */
	// {
	// 	id: 'dc',
	// 	path: dashboardMenu.DCManagement.subMenu.KemHrManagement.path,
	// 	element: <DCMANAGEMENT.KEMUSERMANAGEMENT />,
	// 	exact: true,
	// },
	// {
	// 	id: 'dc',
	// 	path: dashboardMenu.DCManagement.subMenu.SapManagement.path,
	// 	element: <DCMANAGEMENT.SAPMANAGEMENT />,
	// 	exact: true,
	// },
	
	// {
	// 	id: 'dc',
	// 	path: dashboardMenu.DCManagement.subMenu.userManagement.path,
	// 	element: <DCMANAGEMENT.USERMANAGEMENT />,
	// 	exact: true,
	// },
	// /* {
	// 	id: 'dc',
	// 	path: dashboardMenu.DCManagement.subMenu.tempUserManagement.path,
	// 	element: <DCMANAGEMENT.TEMPUSERMANAGEMENT />,
	// 	exact: true,
	// }, */
	// {
	// 	id: 'dc',
	// 	path: dashboardMenu.DCManagement.subMenu.systemAuthorityManagement.path,
	// 	element: <DCMANAGEMENT.SYSTEMAUTHORITYMANAGEMENT />,
	// 	exact: true,
	// },
	// {
	// 	id: 'dc',
	// 	path: dashboardMenu.DCManagement.subMenu.systemAuthApplyManagement.path,
	// 	element: <DCMANAGEMENT.SYSTEMAUTHAPPLYMANAGEMENT />,
	// 	exact: true,
	// },
	// {
	// 	id: 'dc',
	// 	path: dashboardMenu.DCManagement.subMenu.systemUserApplyManagement.path,
	// 	element: <DCMANAGEMENT.SYSTEMUSERAPPLYMANAGEMENT />,
	// 	exact: true,
	// },
	// {
	// 	id: 'dc',
	// 	path: dashboardMenu.DCManagement.subMenu.authUserManagement.path,
	// 	element: <DCMANAGEMENT.AUTHUSERMANAGEMENT />,
	// 	exact: true,
	// },	
	// /*
	//  *	권한관리
	//  */
	// {
	// 	id: 'ccp',
	// 	path: dashboardMenu.authManagement.subMenu.authInquiry.path,
	// 	element: <AUTHMANAGEMENT.AUTHINQUIRY />,
	// 	exact: true,
	// },
	// {
	// 	id: 'ccp',
	// 	path: dashboardMenu.authManagement.subMenu.authMenuManagement.path,
	// 	element: <AUTHMANAGEMENT.AUTHMENUMANAGEMENT />,
	// 	exact: true,
	// },
	// {
	// 	id: 'ccp',
	// 	path: dashboardMenu.authManagement.subMenu.interlockLinkManagement.path,
	// 	element: <AUTHMANAGEMENT.INTERLOCKLINKMANAGEMENT />,
	// 	exact: true,
	// },
	// /* {
	// 	id: 'ccp',
	// 	path: dashboardMenu.authManagement.subMenu.authMenuManagement.path,
	// 	element: <AUTHMANAGEMENT.AUTHUSERMANAGEMENT />,
	// 	exact: true,
	// }, */

	// //srm
	// {
	// 	id: 'srm',
	// 	path: dashboardMenu.srmManagement.subMenu.authInquiry.path,
	// 	element: <SRMAUTHMANAGEMENT.SRMAUTHINQUIRY />,
	// 	exact: true,
	// },
	// {
	// 	id: 'srm',
	// 	path: dashboardMenu.srmManagement.subMenu.authUserRegManagement.path,
	// 	element: <SRMAUTHMANAGEMENT.SRMAUTHUSERREGMANAGEMENT />,
	// 	exact: true,
	// },
	// {
	// 	id: 'srm',
	// 	path: dashboardMenu.srmManagement.subMenu.authPrivManagement.path,
	// 	element: <SRMAUTHMANAGEMENT.SRMAUTHPRIVMANAGEMENT />,
	// 	exact: true,
	// },
	// {
	// 	id: 'srm',
	// 	path: dashboardMenu.srmManagement.subMenu.authUserManagement.path,
	// 	element: <SRMAUTHMANAGEMENT.SRMAUTHUSERMANAGEMENT />,
	// 	exact: true,
	// },
	// //kanban
	// {
	// 	id: 'kanban',
	// 	path: dashboardMenu.kanbanManagement.subMenu.authInquiry.path,
	// 	element: <KANBANAUTHMANAGEMENT.KANBANAUTHINQUIRY />,
	// 	exact: true,
	// },
	// {
	// 	id: 'kanban',
	// 	path: dashboardMenu.kanbanManagement.subMenu.authUserRegManagement.path,
	// 	element: <KANBANAUTHMANAGEMENT.KANBANAUTHUSERREGMANAGEMENT />,
	// 	exact: true,
	// },
	// {
	// 	id: 'kanban',
	// 	path: dashboardMenu.kanbanManagement.subMenu.authPrivManagement.path,
	// 	element: <KANBANAUTHMANAGEMENT.KANBANAUTHPRIVMANAGEMENT />,
	// 	exact: true,
	// },
	// {
	// 	id: 'kanban',
	// 	path: dashboardMenu.kanbanManagement.subMenu.authUserManagement.path,
	// 	element: <KANBANAUTHMANAGEMENT.KANBANAUTHUSERMANAGEMENT />,
	// 	exact: true,
	// },
	// {
	// 	id: 'eai',
	// 	path: dashboardMenu.eaiManagement.subMenu.authUserManagement.path,
	// 	element: <EAIAUTHMANAGEMENT.EAIAUTHUSERMANAGEMENT />,
	// 	exact: true,
	// },

	// {
	// 	id: 'eai',
	// 	path: dashboardMenu.eaiManagement.subMenu.authUserRegManagement.path,
	// 	element: <EAIAUTHMANAGEMENT.EAIAUTHUSERREGMANAGEMENT />,
	// 	exact: true,
	// },
	// {
	// 	id: 'eai',
	// 	path: dashboardMenu.eaiManagement.subMenu.authPrivManagement.path,
	// 	element: <EAIAUTHMANAGEMENT.EAIAUTHPRIVMANAGEMENT />,
	// 	exact: true,
	// },
	// {
	// 	id: 'eai',
	// 	path: dashboardMenu.eaiManagement.subMenu.authUserManagement.path,
	// 	element: <EAIAUTHMANAGEMENT.EAIAUTHUSERMANAGEMENT />,
	// 	exact: true,
	// },
	/*
	 *	조직도관리
	 */
	// {
	// 	id: 'ccp',
	// 	path: dashboardMenu.organizationManagement.path,
	// 	element: <ORGANIZATIONMANAGEMENT.ORGANIZATIONMANAGEMENT />,
	// 	exact: true,
	// },
	{ id: 'login', path: demoPages.login.path, element: <Login />, exact: true },
];

// 게시판
const BOARDS = {
	VIEW: lazy(() => import('../page/Board/BoardView')),
	LIST: lazy(() => import('../page/Board/BoardList')),
	MANAGE: lazy(() => import('../page/Board/BoardManage')),
};

const board = [
	{
		id: 'list-board',
		path: '/board/:type',
		element: <BOARDS.LIST />,
		exact: true,
	},	
	{
		id: 'manage-board',
		path: '/board/:type/M/:idx',
		element: <BOARDS.MANAGE />,
		exact: true,
	},	
	{
		id: 'view-board',
		path: '/board/:type/:idx',
		element: <BOARDS.VIEW />,
		exact: true,
	},
];

const contents = [...presentation, ...board];

export default contents;
